<template>
  <div class="header">
    <div class="header-box">
      <div class="logo-box" @click="toUrl('/')">
        <img src="@/assets/nav/logo.webp" alt="" />
      </div>
      <div class="nav-center">
        <div class="cell cell-1">骆驼产品<img class="dog" v-if="metaTilte == '骆驼产品'" src="@/assets/index/circle-red.webp" alt=""></div>
        <div class="cell cell-2">解决方案<img class="dog" v-if="metaTilte == '电商服务' || metaTilte == '公共事业交通' || metaTilte == '政府机构'" src="@/assets/index/circle-red.webp" alt=""></div>
        <div class="cell cell-3">新闻中心<img class="dog" v-if="metaTilte == '企业动态' || metaTilte == '产品动态' || metaTilte == '视频专区'" src="@/assets/index/circle-red.webp" alt=""></div>
        <div class="cell cell-4">关于骆驼<img class="dog" v-if="metaTilte == '品牌故事' || metaTilte == '品牌实力' || metaTilte == '品牌技术' || metaTilte == '回收业务'" src="@/assets/index/circle-red.webp" alt=""></div>
        <div class="cell" @click="toUrl('/buy/index')">在哪儿买<img class="dog"  v-if="metaTilte == '在哪儿买'" src="@/assets/index/circle-red.webp" alt=""></div>
        <div class="hover-box1 hover-box">
          <div :class="{'item':true,'active-path':$route.fullPath == item.path}" v-for="(item,index) of menuList1" :key="index" @click="toUrl(item.path,index+1)">
            <div class="title">{{item.title}}</div>
            <div class="line"></div>
          </div>
        </div>
        <div class="hover-box2 hover-box">
          <div :class="{'item':true,'active-path':$route.fullPath == item.path}" v-for="(item,index) of menuList2" :key="index" @click="toUrl(item.path)">
            <div class="title">{{item.title}}</div>
            <div class="line"></div>
          </div>
        </div>
        <div class="hover-box3 hover-box">
          <div :class="{'item':true,'active-path':$route.fullPath == item.path}" v-for="(item,index) of menuList3" :key="index" @click="toUrl(item.path)">
            <div class="title">{{item.title}}</div>
            <div class="line"></div>
          </div>
        </div>
        <div class="hover-box4 hover-box">
          <div :class="{'item':true,'active-path':$route.fullPath == item.path}" v-for="(item,index) of menuList4" :key="index" @click="toUrl(item.path)">
            <div class="title">{{item.title}}</div>
            <div class="line"></div>
          </div>
        </div>
      </div>
      <div class="nav-right">
        <div class="cell" @click="toUrl('/info/battery-knowledge')">
          电池知识
          <div class="height"></div>
        </div>
        <div class="cell" @click="toUrl('/download')">
          下载中心
          <div class="height"></div>
        </div>
        <div class="cell" @click="toUrl('/contact-us/index')">联系我们</div>
      </div>
    </div>
    <div :class="{'header-s':true,'header-s-100vh':isShow}">
      <div class="shrink-box">
        <img class="logo" src="@/assets/nav/logo.webp" @click="toUrlApp('/')" alt="">
        <div class="icon-box w-center" @click="isShow = !isShow">
          <img src="@/assets/nav/open.png" alt="">
        </div>
      </div>
      <div class="menu-box">
        <div :class="{'list-box':true}"  v-for="(item,index) of menuListApp" :key="index">
          <div class="title-box" @click="handleChecked(item,index)">
            <span>{{item.title}}</span>
            <span v-if="item.children.length">{{item.checked?'-':'+'}}</span>
          </div>
          <div class="item-box" v-if="item.children.length" :style="{height:item.checked?(item.children.length*0.4+0.26)+'rem':'0'}">
            <div class="height-1"></div>
            <div class="item" v-for="(val,idx) of item.children" :key="idx" @click="toUrlApp(val.path,item.title=='骆驼产品'?idx+1:null)">{{val.title}}</div>
            <div class="height-1"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      menuList1:[
        {title:'乘用车领域',path:'/product/index?current=1'},
        {title:'商用车领域',path:'/product/index?current=2'},
        {title:'农业领域',path:'/product/index?current=3'},
        {title:'工程机械领域',path:'/product/index?current=4'},
        {title:'船用领域',path:'/product/index?current=5'},
        {title:'储能领域',path:'/product/index?current=6'},
        {title:'铅酸动力',path:'/product/index?current=7'},
      ],
      menuList2:[
        {title:'电商服务',path:'/solution/e-commerce'},
        {title:'公共事业',path:'/solution/public-utilities'},
        // {title:'政府机构',path:'/solution/government'}
      ],
      menuList3:[
        {title:'企业动态',path:'/press-center/business-movement'},
        {title:'产品动态',path:'/press-center/product-dynamics'},
        {title:'视频专区',path:'/press-center/video-zone'}
      ],
      menuList4:[
        {title:'品牌故事',path:'/brand-story/introduce'},
        {title:'品牌实力',path:'/about-lt/brand-strength'},
        {title:'品牌技术',path:'/about-lt/brand-technology'},
        {title:'回收业务',path:'/about-lt/battery-recycling'}
      ],
      menuListApp:[
        {
          title:'骆驼产品',
          checked:false,
          children:[
            {title:'乘用车领域',path:'/product/index?current=1'},
            {title:'商用车领域',path:'/product/index?current=2'},
            {title:'农业领域',path:'/product/index?current=3'},
            {title:'工程机械领域',path:'/product/index?current=4'},
            {title:'船用领域',path:'/product/index?current=5'},
            {title:'储能领域',path:'/product/index?current=6'},
            {title:'铅酸动力',path:'/product/index?current=7'}
          ]
        },
        {
          title:'解决方案',
          checked:false,
          children:[
            {title:'电商服务',path:'/solution/e-commerce'},
            {title:'公共事业',path:'/solution/public-utilities'},
          ]
        },
        {
          title:'新闻中心',
          checked:false,
          children:[
            {title:'企业动态',path:'/press-center/business-movement'},
            {title:'产品动态',path:'/press-center/product-dynamics'},
            {title:'视频专区',path:'/press-center/video-zone'}
          ]
        },
        {
          title:'关于骆驼',
          checked:false,
          children:[
            {title:'品牌故事',path:'/brand-story/introduce'},
            {title:'品牌实力',path:'/about-lt/brand-strength'},
            {title:'品牌技术',path:'/about-lt/brand-technology'},
            {title:'回收业务',path:'/about-lt/battery-recycling'}
          ]
        },
        {
          title:'在哪儿买',
          checked:false,
          children:[],
          path:'/buy/index'
        },
        {
          title:'电池知识',
          checked:false,
          children:[
            {title:'蓄电池知识',path:'/info/battery-knowledge'},
            {title:'养护秘籍',path:'/info/maintain'},
            {title:'替换安装',path:'/info/replace'},
          ]
        },
        {
          title:'下载中心',
          checked:false,
          children:[],
          path:'/download'
        },
        {
          title:'联系我们',
          checked:false,
          children:[],
          path:'/contact-us/index'
        },
      ],
      isShow: false,
      isPhone: false,
      animation: false,
      activeName: "1",
      metaTilte:''
    };
  },
  mounted() {
    window.that = this;
    that.metaTilte = this.$route.meta.title
    that.isPhone = that.IsPhone();
    console.log(that.isPhone)
  },
  methods: {
    handleChecked(item,index){
      if(!item.children.length){
        that.$router.push({path:item.path},() => {})
        return
      }
      item.checked = !item.checked
      this.$set(this.menuListApp,index,item)
      if(item.checked){
        this.menuListApp.forEach((val,idx)=>{
          if(index!=idx){
            val.checked = false
          }
        })
      }
    },
    toUrl(path,index) {
      that.$router.push(
        {
          path,
        },
        () => {
          if(index){
            that.$store.commit('setProductCurrent',index)
          }
        }
      );
    },
    toUrlApp(path,index) {
      this.isShow = false
      that.$router.push({path},() => {
          if(index){
            that.$store.commit('setProductCurrent',index)
          }
        }
      );
    },
    IsPhone() {
      //获取浏览器navigator对象的userAgent属性（浏览器用于HTTP请求的用户代理头的值）
      var info = navigator.userAgent;
      // navigator.userAgent.indexOf('mobile')
      //通过正则表达式的test方法判断是否包含“Mobile”字符串
      var isPhone = /mobile/i.test(info);
      //如果包含“Mobile”（是手机设备）则返回true
      return isPhone;
    },
  },
};
</script>
<style lang="scss" scoped>
.header {
  height: 0.6rem;
  // position: fixed;
  // z-index: 9999;
  // width: 100%;
  // height: 0.58rem;
}
@keyframes ebg {
  to {
    width: 100%;
  }
}
.header-box {
  position: fixed;
  z-index: 2000;
  width: 100%;
  // position: relative;
  height: 0.58rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000000;
  &::after {
    content: "";
    height: 2px;
    width: 0%;
    position: absolute;
    bottom: -2px;
    background-color: #e60012;
    left: 0;
    animation: ebg 1.5s ease 0.5s forwards;
  }
  .logo-box {
    position: absolute;
    left: 0;
    top: 0;
    width: 3.6rem;
    height: 0.58rem;
    background: #e60012;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 1.68rem;
      height: 0.45rem;
    }
  }

  .nav-center {
    display: flex;
    align-items: center;
    height: 100%;
    cursor: pointer;

    .cell {
      position: relative;
        width: 1.11rem;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      font-size: 0.16rem;
      font-weight: bold;
      color: #ffffff;
      .dog{
        position: absolute;
        top: 0.16rem;
        right: 0.16rem;
        width: 0.14rem;
        height: 0.14rem;
      }
    }
  }
  .nav-right {
    position: absolute;
    right: 1rem;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;

    .cell {
      position: relative;
      padding: 0 0.14rem;
      font-size: 0.14rem;
      color: #ffffff;
      line-height: 1;
      .height {
        position: absolute;
        top: 0;
        right: 0;
        height: 0.14rem;
        width: 0.02rem;
        background: #ffffff;
      }
    }
  }
}
.hover-box {
  position: fixed;
  top: 0.6rem;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 0;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  box-shadow: 0rem 0.05rem 0.05rem 0 rgba(41, 41, 41, 0.22);
  background: #ffffff;
  cursor: pointer;
  transition-duration: 0.5s;
  overflow: hidden;
  .item{
    position: relative;
    display: flex;
    justify-content: center;
    width: 1.43rem;
    .title{
        display: flex;
        align-items: center;
        font-size: 0.16rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
    }
    .line{
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 0rem;
        height: 0.02rem;
        background: #ED0202;
        transition-duration: 0.5s;
    }
  }
  .active-path{
    .title{
      color: #ED0202;
    }
  }
  .item:hover{
    .line{
        width: 0.7rem;
    }
  }
}
.cell-1:hover~.hover-box1{
    height: 0.6rem;
}
.cell-2:hover~.hover-box2{
    height: 0.6rem;
}
.cell-3:hover~.hover-box3{
    height: 0.6rem;
}
.cell-4:hover~.hover-box4{
    height: 0.6rem;
}
.hover-box1:hover{
    height: 0.6rem;
}
.hover-box2:hover{
    height: 0.6rem;
}
.hover-box3:hover{
    height: 0.6rem;
}
.hover-box4:hover{
    height: 0.6rem;
}

.header-s{
  display: none;
}
@media screen and (max-width: 768px){
  .header{
    .header-box{
      display: none;
    }
  }
  .header-s{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 0.6rem;
    display: block;
    overflow: hidden;
    background: #141414;
    z-index: 1000;
    transition-duration: 0.5s;
    .shrink-box{
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 0.6rem;
      border-bottom: 1px solid #E60012;
      box-sizing: border-box;
      .logo{
        width: 1.53rem;
        height: 0.41rem;
      }
      .icon-box{
        position: absolute;
        top: 0;
        right: 0;
        width: 0.6rem;
        height: 0.6rem;
        background: #E60012;
        img{
          width: 0.33rem;
          height: 0.25rem;
        }
      }
    }
    .menu-box{
      padding: 0.2rem;
      height: auto;
      .list-box{
        // height: 0.6rem;
        min-height: 0.6rem;
        .title-box{
          padding-right: 0.13rem;
          width: 100%;
          height: 0.6rem;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 0.15rem;
          color: #FFFFFF;
        }
        .item-box{
          height: 0;
          padding: 0 0.13rem;
          background: #666666;
          box-sizing: border-box;
          overflow: hidden;
          transition-duration: 0.5s;
          .height-1{
            height: 0.13rem;
          }
          .item{
            font-size: 0.14rem;
            color: #F8F8F8;
            line-height: 0.4rem;
          }
        }
      }
      .list-box+.list-box{
        border-top: 1px solid #666666;
      }
    }
  }
  .header-s-100vh{
    height: 100vh;
    overflow-y: scroll;
  }
}
</style>